function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as constants from './constants';

var Header = function Header(_ref) {
  var children = _ref.children;
  var headerMarkup = null;

  if (children) {
    headerMarkup = React.createElement("header", {
      className: "eds-layout__header",
      "data-spec": "eds-layout__header"
    }, children);
  }

  return headerMarkup;
};

var Body = function Body(_ref2) {
  var children = _ref2.children;
  return React.createElement("div", {
    className: "eds-layout__body",
    "data-spec": "eds-layout__body"
  }, children);
};

var Layout =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Layout, _PureComponent);

  function Layout() {
    _classCallCheck(this, Layout);

    return _possibleConstructorReturn(this, _getPrototypeOf(Layout).apply(this, arguments));
  }

  _createClass(Layout, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          children = _this$props.children,
          header = _this$props.header,
          peakSize = _this$props.peakSize,
          maxWidth = _this$props.maxWidth,
          hasHorizontalGutters = _this$props.hasHorizontalGutters;
      var className = classNames('eds-layout', (_classNames = {}, _defineProperty(_classNames, "eds-layout--has-".concat(peakSize, "-peak"), peakSize), _defineProperty(_classNames, "eds-layout--has-".concat(maxWidth, "-max-width"), maxWidth), _defineProperty(_classNames, 'eds-layout--has-horizontal-gutters', hasHorizontalGutters), _classNames));
      return React.createElement("section", {
        className: className,
        "data-spec": "eds-layout"
      }, React.createElement(Header, null, header), React.createElement(Body, null, children));
    }
  }]);

  return Layout;
}(PureComponent);

_defineProperty(Layout, "propTypes", {
  /**
   * Main page contents of the layout
   */
  children: PropTypes.node.isRequired,

  /**
   * (optional) placeholder of content that will exist above the `children`
   */
  header: PropTypes.node,

  /**
   * (optional) adds a maximum width constrain to the main page contents
   * supports 'large' (1272px)
   */
  maxWidth: PropTypes.oneOf(constants.MAX_WIDTHS),

  /**
   * (optional) The amount the `children` should overlap the `header`
   * supports 'small', 'medium' or 'large' peak sizes
   */
  peakSize: PropTypes.oneOf(constants.PEAK_SIZES),

  /**
   * (optional) Turns on horizontal gutters
   * Small Narrow (360px) - 16px
   * Small (480px) - 16px
   * Small Wide (660px) - 16px
   * Medium Narrow (792px) - 24px
   * Medium (960px) - 24px
   * Medium Wide (1080px) - 24px
   * Large Narrow (1152px) - 48px
   * Large (1272px) - 48px
   * Large Wide (1608px) - 72px
   */
  hasHorizontalGutters: PropTypes.bool
});

_defineProperty(Layout, "defaultProps", {
  hasHorizontalGutters: false
});

export { Layout as default };